import React from 'react';
import Icon from '../AppIcon';

const Breadcrumbs = ({ items = [], className = '' }) => {
  const handleBreadcrumbClick = (path) => {
    if (path) {
      window.location.href = path;
    }
  };

  if (!items || items?.length === 0) {
    return null;
  }

  return (
    <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {items?.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={14} 
                className="text-text-secondary mx-2" 
              />
            )}
            {item?.path && index < items?.length - 1 ? (
              <button
                onClick={() => handleBreadcrumbClick(item?.path)}
                className="text-text-secondary hover:text-primary transition-smooth font-medium"
              >
                {item?.label}
              </button>
            ) : (
              <span className={`font-medium ${index === items?.length - 1 ? 'text-text-primary' : 'text-text-secondary'}`}>
                {item?.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;